import React, { useState } from 'react';
import FeedbackListElement from './FeedbackListElement.js';

import './TestListElement.css';

const TestListElement = ({ testData, onButtonClick }) => {
    const [overriddenStatus, setOverriddenStatus] = useState(testData.manual_override);

    const handleButtonClick = () => {
        setOverriddenStatus(prevStatus => {
            const newStatus = prevStatus ? 0 : 1;
    
            let checkToUpdate = {
                checkFlagData: testData,
                overriddenStatus: newStatus,
                objectType: 'check'
            };
            onButtonClick(checkToUpdate);
    
            return newStatus;
        });
    
        console.log('overriddenStatus changed');
    };

    return (
        <FeedbackListElement
            testType={testData.test_type}
            impactAttribute={testData.impact_attribute}
            testName={testData.test_name}
            result={testData.result}
            issueMessage={testData.issue_message}
            failureMode={testData.failure_mode}
            overriddenStatus={overriddenStatus}
        >
            {testData.impact_attribute === 'info' && (
                <div className="element-value">
                    Info
                </div>
            )}

            {testData.impact_attribute !== 'info' && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {testData.result === 0 && testData.impact_attribute == 'disabled for now' && (
                        <button className="enter-button" onClick={handleButtonClick}>
                            {overriddenStatus ? 'Reinstate' : 'Override'}
                        </button>
                    )}
                    <div className="element-value" style={{ color: testData.result === null ? '#ccc' : (testData.result ? '#29ba46' : '#e83838') }}>
                        {testData.result === null ? 'Not Applicable' : (testData.result ? 'Passed' : 'Failed')}
                    </div>
                </div>
            )}
        </FeedbackListElement>
    );
};

export default TestListElement;